


















import SmsAccount from '@/types/SmsAccount.interface'
import Vue from 'vue'
export default Vue.extend({
    data: () => ({
        areaCode: null,
        empty: false,
        error: false,
        loading: false,
        numbers: null,
        selectedNumber: null,
        step: 1
    }),
    computed: {
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        smsAccount(): SmsAccount {
            return this.$store.getters.smsAccount
        }
    },
    methods: {
        onContactSupport() {
            //  @ts-ignore If we are on the mobile app, then call our Cordova plugin
            if (this.isApp) intercom.displayMessenger()
            // Pops the intercom messenger through the id bound to the hidden span element
            else window.popSupportMessenger()
        }
    }
})
